/* tslint:disable */
/* eslint-disable */
export enum ScreenPhase {
  FORM,
  EMAIL_SENT
}

export enum MagicLinkState {
  ATTEMPTING_AUTO_LOGIN,
  ENABLED,
  LOADING,
  FAILED
}
